<template>
    <div id="finishes">
        <div class="holder" v-if="holder"></div>
        <div v-else>
            <PageIntro title="Acabamentos"/>
            <CatCarousel :pages="pages" :products="products" finishes="true" :categories="cat"/>
            <div class="page-scroll" ref="pageScroll"></div>
            <div class="container products">
                <div v-for="(product) in products"
                     :key="product.id"
                     @click="openLightbox(product)"
                     class="product">
                    <lazy-image :image="product.file" :radius="4" position="absolute"></lazy-image>
                    <div class="product__holder">
                        <h3 class="product__title">{{product.name}}</h3>
                        <span class="product__desc">{{product.text.toUpperCase()}}</span>
                        <div class="arrow1"></div>
                        <div class="arrow2"></div>
                        <div class="arrow3"></div>
                        <div class="arrow4"></div>
                    </div>
                </div>
            </div>
            <div class="page">
                <div class="ball"
                     :class="{active: page === index + 1}"
                     @click="fetchPage(index + 1)"
                     v-for="(currentPage, index) in pages" :key="currentPage + 'finishes'">{{index + 1}}</div>
            </div>
            <TendenciesCarousel :content="productCarousel"/>
        </div>
        <Lightbox @closeLightbox="closeLightBox"
                  :single="true"
                  :singleSrc="imageSource"
                  :toggle="toggleLightbox"/>
    </div>
</template>

<script>
    import TendenciesCarousel from "../components/Shared/TendenciesCarousel";
    import CatCarousel from "../components/Shared/CatCarousel";
    import PageIntro from "../components/Shared/PageIntro";
    import Lightbox from "../components/Shared/Lightbox";
    import LazyImage from "../components/Shared/LazyImage";

    export default {
        name: "Finishes",
        props: ['id'],
        data() {
            return {
                cat: [],
                products: [],
                holder:true,
                pages: null,
                productCarousel: [],
                toggleLightbox: false,
                imageSource: '',
                page: 1,
            }
        },
        methods: {
            fetchCarousel() {
                axios.get('/productdestc')
                    .then(r => {
                        this.productCarousel = r.data.data;
                    })
            },
            fetchCategories() {
                axios.get('/categoriaAcabamento')
                    .then(r => {
                        this.cat = r.data;
                        this.fetchProducts();
                        this.holder = false;
                    })
            },
            fetchProducts() {
                if(this.id) {
                    axios.get(`/acabamento?per-page=12&categoria=${this.id}`)
                        .then(r => {
                            this.products = r.data.data;
                            this.pages = r.data.last_page;
                        })
                }
            },
            fetchPage(id) {
                this.page = id;

                axios.get(`/acabamento?per-page=12&categoria=${this.id}&page=${id}`)
                    .then(r => {
                        this.products = r.data.data;
                        this.$refs.pageScroll.scrollIntoView({
                            block: 'start',
                            behavior: 'smooth'
                        })
                    })
            },
            openLightbox(product) {
                this.toggleLightbox = true;
                this.imageSource = product.file.permalink;
            },
            closeLightBox(val) {
                this.toggleLightbox = val;
            },
        },
        watch: {
            '$route.params': {
                handler: function (v) {
                    const page = parseInt(v.page);
                    if(!isNaN(page)) {
                        this.page = page;
                    }
                    this.fetchProducts();
                    this.fetchCarousel();
                }
                ,
                immediate: true
            }
        },
        mounted() {
            window.scrollTo({
                top: 0,
                behavior: 'auto'
            })
        },
        created() {
            this.fetchCategories();
            this.fetchCarousel();
            document.title = 'Fibrillare - Acabamentos';
        },
        components: {
            TendenciesCarousel,
            CatCarousel,
            PageIntro,
            Lightbox,
            LazyImage
        },
    }
</script>

<style lang="scss" scoped>
    .products {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
    }

    .product {
        cursor: pointer;
        display: block;
        width: 270px;
        height: 270px;
        background-size: cover;
        background-position: center center;
        background-repeat: no-repeat;
        border-radius: 4px;
        margin-bottom: 20px;
        position: relative;

        &__title {
            font-family: "Open Sans";
            font-weight: 500;
            font-size: 1rem;
            text-align: center;
            color: #fff;

            &::after {
                content: '';
                display: block;
                width: 58px;
                height: 2px;
                background: #47afb3;
                margin: 5px auto 0 auto;
            }
        }

        &__desc {
            display: block;
            font-size: 0.75rem;
            font-family: "Open Sans";
            text-align: center;
            font-weight: 300;
            color: #fff;
            margin-top: 10px;
        }

        &__holder {
            margin: 40px;
            height: 190px;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            position: relative;
            opacity: 0;
            transition: all .3s;
            transform: translate3d(0, 30px, 0);
            z-index: 1;
        }
    }

    .product:hover .product__holder {
        opacity: 1;
        transform: translate3d(0, 0, 0);
    }

    .product::after {
        background: rgba(0, 0, 0, .6);
        content: '';
        display: block;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        border-radius: 4px;
        height: 100%;
        z-index: 0;
        opacity: 0;
        transition: all .2s;
    }

    .product:hover.product::after {
        opacity: 1;
    }

    .arrow1 {
        position: absolute;
        left: 0;
        top: 0;
        width: 17px;
        height: 17px;
        border-left: 2px solid #fff;
        border-top: 2px solid #fff;
    }

    .arrow2 {
        position: absolute;
        top: 0;
        right: 0;
        width: 17px;
        height: 17px;
        border-right: 2px solid #fff;
        border-top: 2px solid #fff;
    }

    .arrow3 {
        position: absolute;
        bottom: 0;
        right: 0;
        width: 17px;
        height: 17px;
        border-right: 2px solid #fff;
        border-bottom: 2px solid #fff;
    }

    .arrow4 {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 17px;
        height: 17px;
        border-bottom: 2px solid #fff;
        border-left: 2px solid #fff;
    }

    @media only screen and (max-width: 1024px) {
        .product:hover .product__holder {
            opacity: 0;
        }
    }

    @media only screen and (max-width: 768px) {
        .products {
            justify-content: space-around;
        }
    }
</style>